// PDP Personalization Preview (personalized-anti-pull template)
(() => {
  // Mirrors the name/phone inputs onto the preview image live as the shopper
  // types. Purely cosmetic — the inputs themselves already submit as line
  // item properties via their `name` attributes, no cart-side JS needed here.
  const initPersonalize = () => {
    const preview = document.querySelector('[data-c-personalize-preview]');
    if (!preview || preview.dataset.personalizeInit) return;
    preview.dataset.personalizeInit = '1';

    // The theme's real personalization inputs (sections/main-product.liquid)
    // — not created here, just read from.
    const nameInput = document.getElementById('custom-name');
    const phoneInput = document.getElementById('custom-phone');
    const nameLabel = preview.querySelector('[data-c-personalize-preview-name]');
    const phoneLabel = preview.querySelector('[data-c-personalize-preview-phone]');

    // Shrinks the name label with a fixed step-down so a long name still
    // fits inside the strap width instead of overflowing it. Reads the
    // CSS-defined size first (rather than a hardcoded number) since
    // assets/c-pdp-personalize.css sets a different base size per breakpoint.
    const fitName = () => {
      if (!nameLabel) return;
      nameLabel.style.fontSize = '';
      // cqw is relative to `preview` (the container-type: inline-size
      // ancestor), not nameLabel's immediate parent (.overlay).
      const baseSizeCqw = parseFloat(getComputedStyle(nameLabel).fontSize) /
        (preview.clientWidth / 100);
      const maxWidth = nameLabel.parentElement.clientWidth;
      let scale = 1;
      while (nameLabel.scrollWidth > maxWidth && scale > 0.4) {
        scale -= 0.05;
        nameLabel.style.fontSize = `${scale * baseSizeCqw}cqw`;
      }
    };

    // Matches the 15-character limit on the #custom-name input
    // (maxlength + input filter in sections/main-product.liquid).
    // fitName() shrinks the font so longer names still fit the strap.
    const MAX_PATCH_NAME_LENGTH = 15;

    const syncName = () => {
      if (!nameInput || !nameLabel) return;
      const name = nameInput.value.trim().toUpperCase().slice(0, MAX_PATCH_NAME_LENGTH);
      nameLabel.textContent = name;
      fitName();
    };

    const syncPhone = () => {
      if (!phoneInput || !phoneLabel) return;
      phoneLabel.textContent = phoneInput.value.trim();
    };

    // Delegated on document (not bound to the inputs directly) so this runs
    // in the bubble phase, after main-product.liquid's own document-level
    // 'input' listener has already reformatted #custom-phone's value
    // (snippets/printed-phone.liquid) — reading it directly off the input would race that
    // formatter and show the pre-format keystroke.
    document.addEventListener('input', (e) => {
      if (e.target === nameInput) syncName();
      if (e.target === phoneInput) syncPhone();
    });
    window.addEventListener('resize', fitName);

    syncName();
    syncPhone();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPersonalize);
  } else {
    initPersonalize();
  }
})();
